<template>
  <div class="text-center">
    <h2 class="txt-head text-center">
      แบบฟอร์มการขอใช้เอกสาร
    </h2>
    <v-divider
      class="mx-4"
      inset
      vertical
    ></v-divider>
    <v-layout :class="$vuetify.breakpoint.name !== 'lg'? 'row':'row ml-10'">
      <v-col cols="4" lg=3 md=3 sm=3>
      <p class="txt-font text-left" :style="$vuetify.breakpoint.name !== 'lg'? 'margin-top: -8px;':'margin-top: 1.5%;'">ประเภทเอกสาร</p>
      </v-col>
      <v-col cols="8" lg=6 md=6 sm=6 class="form-control">
        <v-select
          v-model="formType"
          :items="itemFormType"
          item-text="typeName"
          item-value="_id"
          @change="searchSelect(formType)"
          label="เลือก ประเภทเอกสาร"
          dense
          outlined
        ></v-select>
      </v-col>
    </v-layout>
    <v-layout :class="$vuetify.breakpoint.name !== 'lg'? 'row':'row ml-10'">
      <v-col cols="4" lg=3 md=3 sm=3>
        <p class="txt-font text-left" :style="$vuetify.breakpoint.name !== 'lg'? 'margin-top: -8px;':'margin-top: 1.5%;'">Service ที่ต้องการใช้งาน</p>
      </v-col>
      <v-col cols="8" lg=6 md=6 sm=6 class="form-control">
        <v-select
          v-model="service"
          :items="itemService"
          item-text="serviceName"
          item-value="_id"
          label="เลือก Service"
          :disabled="formType == ''"
          dense
          outlined
        ></v-select>
      </v-col>
    </v-layout>
    <v-layout :class="$vuetify.breakpoint.name !== 'lg'? 'row':'row ml-10'">
      <v-col cols="4" lg=3 md=3 sm=3>
        <p class="txt-font text-left" style="margin-top: 1.5%;">ผู้อนุมัติ</p>
      </v-col>
      <v-col cols="8" lg=6 md=6 sm=6  class="form-control">
        <v-select
          v-model="nameApprove"
          :items="nameGroupList"
          label="ผู้อนุมัติ"
          readonly
          multiple
          chips
          outlined
          append-icon=""
        >
        <template #selection="{ item }">
          <v-chip color="green !important">
            <span class="filter-chip_department">{{item}}</span>
          </v-chip>
        </template>
        </v-select>
      </v-col>
    </v-layout>
    <v-layout :class="$vuetify.breakpoint.name !== 'lg'? 'row':'row ml-10'">
      <v-col cols="4" lg=3 md=3 sm=3>
        <p class="txt-font text-left" style="margin-top: 1.5%;">หมายเหตุ</p>
      </v-col>
      <v-col cols="8" lg=6 md=6 sm=6 >
        <v-textarea
          v-model="note"
          outlined
          label="หมายเหตุ"
        ></v-textarea>
      </v-col>
    </v-layout>
    <div class="text-right" style="margin-top: 20px;">
    <v-btn class="ma-2 create-orgchart-header-cancel-btn" color="red" dark @click="goback()">ยกเลิก</v-btn>
    <v-btn class="ma-2 create-orgchart-header-cancel-btn" color="success" @click="submitData()">บันทึก
    </v-btn>
    </div>
  </div>
</template>
<script>
import { getUserByKeyword, getServiceList, searchSelectService, insertRequest } from '@/API/API'
import swal from 'sweetalert'
export default {
  components: {
    // OverlayLoading
  },
  data () {
    return {
      formType: '',
      service: '',
      itemFormType: [],
      itemService: [],
      nameApprove: [],
      nameGroupList: [],
      note: '',
      textList: '',
      approverList: []

    }
  },
  created () {
    this.tokenUser = this.$store.state.token
    this.getService()
  },
  watch: {
    service: function (val) {
      this.approverList = []
      var filterValue = this.itemService.filter(r => {
        if (r._id === val) {
          return r
        }
      })
      this.textList = filterValue[0].approver
      for (let index = 0; index < this.textList.length; index++) {
        this.approverList.push(
          this.textList[index].approverName
        )
      }
      this.nameApprove = this.approverList
      this.nameGroupList = this.approverList
    }
  },
  methods: {
    goback () {
      this.$router.go(-1)
      // this.$router.push('/authorityservices/requestservicelist')
    },
    async getService () {
      this.loading = true
      this.selectData = []
      // const token = this.tokenUser
      try {
        const res = await getServiceList(this.tokenUser)
        if (res.success) {
          this.itemFormType = res.result[0].typeName
          if (res.result.length) {
          }
          // console.log(res)
        } else {
          // console.log(res)
        }
      } catch (error) {
        // alert(error)
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async searchSelect () {
      this.titleDepartment = this.type
      const obj = {
        serviceTypeId: this.formType
      }
      try {
        const res = await searchSelectService(obj, this.tokenUser)
        if (res.result) {
          this.itemService = res.result
          // console.log('Approve List', res.result)
          // console.log('Service Name', this.service)
        } else {
          swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
            button: false,
            timer: 2000
          })
        }
      } catch (error) {
        console.log(error)
        swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
          button: false,
          timer: 2000
        })
      } finally {
        this.loading = false
      }
    },
    async getUser () {
      this.loading = true
      var temp = []
      const obj = {
        search: ''
      }
      try {
        const res = await getUserByKeyword(obj, this.tokenUser)
        if (res.success) {
          temp = res.result
          this.itemUser = temp
          this.states = temp
          // console.log('Data User', temp)
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async submitData () {
      if (this.service === '' || this.note === '') {
        swal('Warning', 'กรุณากรอกข้อมูลให้ครบ', 'warning')
      } else {
        const obj = {
          serviceId: this.service,
          comment: this.note
        }
        // console.log('OBJ', obj)
        try {
          const res = await insertRequest(obj, this.tokenUser)
          // console.log('Res', res)
          if (res.success) {
            swal('สำเร็จ', 'บันทึกข้อมูลสำเร็จ', 'success', {
              button: false,
              timer: 2000
            })
            this.$router.go(-1)
          }
        } catch (error) {
          swal('ผิดพลาด', 'บันทึกข้อมูล ไม่สำเร็จ!', 'error')
          console.log(error)
        } finally {
          this.loading = false
        }
      }
      // this.$router.go(-1)
    }
  }
}
</script>
<style>
@import '../../../css/Create.css';
</style>
